import { http } from '../../core/services/http';

export const loadZipCodeBoundaries = (zipCodes: string[]) =>
  http.post(`/common/zipCodeBoundaries`, { zipCodes }).then(response => response.data);
